const BaseError = require('make-error').BaseError;

class DeviceUnknownError extends BaseError {
    constructor(errorMessage='Device unknown. Register the device and try again.') {
        super(errorMessage);
        this._isUserError = true;
    }
}

module.exports = DeviceUnknownError;